import { defineStore } from "pinia";

import type {
  IKundserviceAppApiClient,
  ISvarsmall,
} from "@/composables/KundserviceAppApiClient";

interface SvarsmallarState {
  initialized: boolean;
  svarsmallar: ISvarsmall[];
  isLoading: boolean;

  _defaultFirstAnswerId?: string | null;
}

export const useSvarsmallarStore = defineStore("svarsmallarStore", {
  state: (): SvarsmallarState => ({
    initialized: false,
    _defaultFirstAnswerId: null,
    svarsmallar: [],
    isLoading: false,
  }),
  getters: {
    getSvarsmallarByLanguage:
      (state: SvarsmallarState) => (language: "sv" | "en") => {
        return state.svarsmallar.filter((mall) => mall.language === language);
      },
    getGroupedSvarsmallar: (state: SvarsmallarState) => {
      const groups = state.svarsmallar.reduce(
        (groups, item) => {
          const key = item.language === "en" ? "Engelska" : item.category;
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(item);
          return groups;
        },
        {} as { [key: string]: ISvarsmall[] },
      );

      if (groups["Engelska"]) {
        const engelskaItems = groups["Engelska"];
        delete groups["Engelska"];
        groups["Engelska"] = engelskaItems;
      }

      return groups;
    },
    defaultFirstAnswerMall: (state: SvarsmallarState) => {
      return (
        state.svarsmallar.find(
          (mall) => mall.id === state._defaultFirstAnswerId,
        ) || null
      );
    },
    getById: (state: SvarsmallarState) => (id: string) => {
      return state.svarsmallar.find((mall) => mall.id === id) || null;
    }
  },
  actions: {
    async init(apiClient: IKundserviceAppApiClient) {
      try {
        if (this.initialized) {
          return;
        }

        this.isLoading = true;
        const svarsmallar = await apiClient.getSvarsmallar();
        this.svarsmallar = svarsmallar.templates;
        this._defaultFirstAnswerId = svarsmallar.defaultFirstAnswerId;
        this.initialized = true;
      } catch (error) {
        console.error("Error fetching svarsmallar. ", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
